import { useTranslation } from "react-i18next";
import type { FC } from "react";

export const WhoWeAre: FC = () => {
  const { t } = useTranslation();

  return (
    <section className="py-12 sm:py-16 lg:py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-3 gap-6 sm:gap-8 items-stretch">

        {/* LEFT STATS CARD */}
        <div 
          className="text-white rounded-2xl sm:rounded-3xl p-8 sm:p-10 flex flex-col justify-between bg-contain bg-center bg-no-repeat relative overflow-hidden min-h-[300px] sm:min-h-[350px] lg:min-h-[400px] shadow-lg"
          style={{ backgroundImage: "url('/Automation-Topology.jpg')" }}
        >
         
        </div>

        {/* CENTER + RIGHT MERGED */}
        <div className="lg:col-span-2 border border-gray-200 rounded-2xl sm:rounded-3xl flex flex-col lg:flex-row items-stretch overflow-hidden">

          {/* TEXT */}
          <div className="flex-1 p-6 sm:p-8 lg:p-10 flex flex-col justify-center order-2 lg:order-1">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold text-gray-900 mb-4 sm:mb-6">
              {t("who_heading")} <span className="text-[#7EDE56]">{t("who_heading_highlight")}</span>
            </h2>

            <p className="text-sm sm:text-base lg:text-lg text-gray-600 leading-relaxed">
              {t("who_description")}
            </p>
          </div>

          {/* IMAGE */}
          <div className="flex-1 order-1 lg:order-2">
            <img
              src="/who.webp"
              alt="Team working"
              className="
                w-full 
                h-[250px] sm:h-[300px] lg:h-[400px] 
                object-cover object-center
                lg:rounded-tr-3xl lg:rounded-br-3xl
                lg:rounded-tl-[120px] lg:rounded-bl-[120px]
                rounded-tl-2xl rounded-tr-2xl
                lg:rounded-tl-[120px]
              "
            />
          </div>

        </div>
      </div>
    </section>
  );
};